export interface Message {
  column_name: ColumnMessageWrapper[];
}

export interface ColumnMessageWrapper {
  column_name: MessagePayload;
}

export interface MessagePayload {
  message: string;
}

